<template>
  <div>
    <!-- 配送单回退重新报价记录 -->
    <el-dialog :title="$t('message.deliveryOrderRollbackRequotationRecord')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1248px" center>
      <div class="content">
        <div class="row">
          <!-- 回退原因： -->
          <div class="label">{{ $t('message.reasonForBackOff') }}:</div>
          <div class="val">
            <!--  回退原因-->
            <el-select v-model="datas.reason" placeholder="回退原因选择" filterable clearable>
              <el-option v-for="item in backReasonOption" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <!-- 具体回退说明 -->
          <div class="label">{{ $t('message.detailsAboutTheRollback') }}:</div>
          <div class="val">
            <el-input type="textarea" v-model="datas.reason_desc"></el-input>
          </div>
        </div>
        <div class="row">
          <!-- 截图添加 -->
          <div class="label">{{ $t('message.screenshotAddition') }}:</div>
          <div class="val">
            <div class="val client_images">
              <el-upload :action="baseURL + '/api/common/uploadFile'" list-type="picture-card" :file-list="images"
                :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :before-upload="beforeAvatarUpload"
                :on-success="handleAvatarSuccess">
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- 国际运费是否回退 -->
          <div class="label">{{ $t('message.whetherTheInternationalFreightIsRefunded') }}:</div>
          <div class="val">
            <!-- 退给客户 -->
            <el-radio v-model="datas.is_logistics_fee_refund" label="1">{{ $t('message.returnToCustomer') }}</el-radio>
            <!-- 通关手续费 -->
            <el-radio v-model="datas.is_logistics_fee_refund" label="0">
              {{ $t('message.noReturnToCustomer') }}
            </el-radio>
          </div>

          <!-- 通关手续费 -->
          <div class="label">{{ $t('message.customsClearanceFee') }}:</div>
          <div class="val">
            <!-- 退给客户 -->
            <el-radio v-model="datas.is_service_fee_refund" label="1">{{ $t('message.returnToCustomer') }}</el-radio>
            <!-- 不退给客户 -->
            <el-radio v-model="datas.is_service_fee_refund" label="0">
              {{ $t('message.noReturnToCustomer') }}
            </el-radio>
          </div>
        </div>
        <!--配送单具体发送方式其他费用： -->
        <h6>{{ $t('message.otherChargesForTheSpecificDeliveryMethodOfTheDeliveryOrder') }}：</h6>
        <div class="table">
          <ol>
            <li class="flex03">NO</li>
            <!-- 配送单号 -->
            <li class="flex15">{{ $t("message.deliveryNoteNumber") }}</li>
            <!-- 箱号 -->
            <li>{{ $t("message.boxNO") }}</li>
            <!-- 具体发送方式 -->
            <li>{{ $t("message.specificSendingMode") }}</li>
            <!-- 收费类别 -->
            <li class="flex15">{{ $t("message.chargeType") }}</li>
            <!-- 收费名义 -->
            <li>{{ $t("message.nominalCharge") }}</li>
            <!-- 收费金额.元 -->
            <li>{{ $t("message.theAmountChargedYuan") }}</li>
            <!-- 是否退给客户 -->
            <li class="flex2">
              {{ $t("message.whetherToReturnToTheCustomer") }}
            </li>
          </ol>
          <ul v-for="(item, index) in detail.other_price_list" :key="index">
            <li class="flex03">{{ index + 1 }}</li>
            <!-- 配送单号 -->
            <li class="flex15">
              {{ item.porder_sn }}
            </li>
            <!-- 箱号 -->
            <li>
              {{ item.number }}
            </li>
            <!-- 具体发送方式 -->
            <li>
              {{ logisticsName(item.logistics_id) }}
            </li>
            <!-- 收费类别 -->
            <li class="flex15">
              {{ getOtherFeeName(item.type) }}
            </li>
            <!-- 收费名义 -->
            <li>
              {{ item.desc }}
            </li>
            <!-- 收费金额.元 -->
            <li>
              {{ item.fee }}
            </li>
            <li class="flex2">
              <!-- 退给客户 -->
              <el-radio v-model="item.is_refund" label="1">{{ $t('message.returnToCustomer') }}</el-radio>
              <!-- 不退给客户 -->
              <el-radio v-model="item.is_refund" label="0">{{ $t('message.noReturnToCustomer') }}</el-radio>
            </li>
          </ul>
          <div v-if="detail.other_price_list == false" class="noData">
            暂无数据
          </div>
        </div>
        <!--追加收费： -->
        <h6>{{ $t('message.additionalCharge') }}：<el-button type="success" size="mini" @click="add">
            {{ $t('message.add') }}</el-button>
        </h6>
        <div class="addExpense">
          <div class="table">
            <ol>
              <li class="flex03">NO</li>
              <!-- 收费名义 -->
              <li>{{ $t("message.nominalCharge") }}</li>
              <!-- 备注说明 -->
              <li>{{ $t("message.remarks") }}</li>
              <!-- 收费金额.元 -->
              <li>{{ $t("message.theAmountChargedRi") }}</li>
              <!-- 操作 -->
              <li class="flex03">{{ $t("message.operation") }}</li>
            </ol>
            <ul v-for="(item, index) in datas.other_fee_charge" :key="index">
              <li class="flex03">{{ index + 1 }}</li>
              <!-- 收费名义 -->
              <li><el-select v-model="item.type" :placeholder="$t('message.nominalCharge')" filterable clearable>
                  <el-option v-for="item in backChargeOption" :key="item.id" :label="item.name" :value="item.name">
                  </el-option>
                </el-select></li>
              <!-- 备注说明 -->
              <li>
                <el-input type="textarea" v-model="item.desc"></el-input>
              </li>
              <!-- 收费金额.元 -->
              <li> <el-input v-model="item.fee" type="number"></el-input></li>
              <!-- 操作 -->
              <li class="flex03"> <el-button type="primary" class="dark" size="mini" @click="del(index)">
                  {{ $t("message.delete") }}</el-button>
              </li>
            </ul>
            <div v-if="datas.other_fee_charge == false" class="noData">
              暂无数据
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确认提出 -->
        <el-button type="primary" @click="backAfterDelivery">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      dialogVisible: false,
      backChargeOption: [],
      backReasonOption: [],
      otherFeeTypes: [],
      images: [],
      datas: {
        porder_sn: this.$route.query.porder_sn,
        reason: '',
        reason_desc: '',
        is_logistics_fee_refund: '1',
        is_service_fee_refund: '1',
        other_fee_charge: [{ type: '', desc: '', fee: '' }],
        other_fee_refund: [],
      },
      porder_sn: this.$route.query.porder_sn,
      imgDialogVisible: false,
      dialogImageUrl: '',
    };
  },
  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,
      detail: (state) => state.porderDetail.detail,

    }),
  },

  methods: {
    // 物流方式转换
    logisticsName(id) {
      let name;
      this.logisticsList.forEach((item) => {
        if (item.id == id) {
          name = item.name;
        }
      });
      return name;

    },
    //回退追加收费名义
    backChargeList() {
      this.$api.porderApi.backChargeList().then((res) => {
        this.backChargeOption = res.data;
      });
    },
    // 回退原因
    backReasonList() {
      this.$api.porderApi.backReasonList().then((res) => {
        this.backReasonOption = res.data;
      });
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    //删除
    handleRemove(file, fileList) {
      this.images = fileList;
    },
    handleAvatarSuccess(res, file, fileList) {
      this.images = fileList;
    },
    // 收费类别name
    getOtherFeeName(type) {
      let name;
      this.otherFeeTypes.forEach((item) => {
        if (item.key == type) {
          name = item.value;
        }
      });
      return name;
    },
    // 收费类别
    getOtherFeeTypes() {
      this.$api.porderApi.otherFeeTypes().then((res) => {
        this.otherFeeTypes = res.data;
      });
    },
    // 新增
    add() {
      this.datas.other_fee_charge.push({ type: '', desc: '', fee: '' })
    },
    //删除
    del(i) {
      this.datas.other_fee_charge.splice(i, 1)
    },
    // 已出货配送单回退
    backAfterDelivery() {
      this.datas.images = []
      this.datas.other_fee_refund = []
      this.images.forEach(item => {
        this.datas.images.push(item.response.data)
      })
      this.detail.other_price_list.forEach(item => {
        this.datas.other_fee_refund.push({
          id: item.id,
          is_refund: item.is_refund
        })
      })
      console.log(this.datas);
      this.$api.porderApi.backAfterDelivery(this.datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
        this.$store.dispatch("getLogisticsList"); //物流方式获取

      })

    },

  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.backChargeList()
        this.backReasonList()
        this.getOtherFeeTypes()

      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-radio__input {
  transform: scale(1.5) !important;
}

.content {
  padding: 0 20px;
  font-size: 16px;

  .row {
    display: flex;
    margin-bottom: 15px;
    line-height: 40px;

    .label {
      width: 140px;
      margin-right: 10px;
    }

    .val {
      flex: 1;
    }
  }

  h6 {
    margin-bottom: 15px;
  }
}

.table {
  font-size: 14px;
  margin-bottom: 15px;

  ul {
    padding: 20px 0;
  }

  .flex03 {
    flex: 0.3
  }

  .flex15 {
    flex: 1.5;
  }

  .flex2 {
    flex: 2;
  }
}

.noData {
  padding: 20px 0;
  text-align: center;
}

.addExpense {
  width: 70%;

  li {
    padding: 0 20px;
  }
}
</style>